import React, { useEffect, useState } from "react";
import { adminApi } from "./api";
import LeadsTable from "./LeadsTable";
import { Loader2, ShieldCheck, ScrollText, Trash2, Plus } from "lucide-react";

function Allowlist() {
  const [rows, setRows] = useState(null);
  const [email, setEmail] = useState("");
  const load = () => adminApi.allowlist().then(setRows);
  useEffect(() => { load(); }, []);
  const add = async () => { if (!email.trim()) return; await adminApi.setAllow(email.trim().toLowerCase(), true); setEmail(""); load(); };
  const toggle = async (r) => { await adminApi.setAllow(r.email, !r.active); load(); };
  if (!rows) return <Loader2 className="h-5 w-5 animate-spin text-violet-500" />;
  return (
    <div className="rounded-2xl bg-white border border-slate-200 p-5" data-testid="settings-allowlist">
      <h3 className="text-[15px] font-extrabold text-slate-900 flex items-center gap-2 mb-1"><ShieldCheck className="h-4 w-4 text-violet-600" /> Allowed accounts</h3>
      <p className="text-[13px] text-slate-500 mb-4">Only active Google accounts here can sign in. Toggle off to lock out instantly.</p>
      <div className="space-y-2 mb-4">
        {rows.map((r) => (
          <div key={r.email} className="flex items-center justify-between rounded-xl border border-slate-100 px-3 py-2.5">
            <div><p className="text-[14px] font-semibold text-slate-800">{r.email}</p><p className="text-[11px] text-slate-400">{r.role || "master"}</p></div>
            <button onClick={() => toggle(r)} data-testid={`allow-toggle-${r.email}`} className={`rounded-full px-3 py-1 text-[12px] font-bold ${r.active ? "bg-emerald-100 text-emerald-700" : "bg-slate-200 text-slate-500"}`}>{r.active ? "Active" : "Inactive"}</button>
          </div>
        ))}
      </div>
      <div className="flex gap-2">
        <input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="add gmail address" className="flex-1 rounded-lg border border-slate-200 px-3 py-2 text-[13px]" />
        <button onClick={add} className="inline-flex items-center gap-1 rounded-lg bg-violet-600 text-white px-3 py-2 text-[13px] font-semibold"><Plus className="h-4 w-4" /> Add</button>
      </div>
    </div>
  );
}

function AuditLog() {
  const [rows, setRows] = useState(null);
  const [actor, setActor] = useState("");
  const load = () => adminApi.audit(actor ? `actor=${encodeURIComponent(actor)}` : "").then(setRows);
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [actor]);
  return (
    <div className="rounded-2xl bg-white border border-slate-200 p-5" data-testid="settings-audit">
      <h3 className="text-[15px] font-extrabold text-slate-900 flex items-center gap-2 mb-3"><ScrollText className="h-4 w-4 text-violet-600" /> Audit log</h3>
      <input value={actor} onChange={(e) => setActor(e.target.value)} placeholder="filter by admin email" className="mb-3 w-64 rounded-lg border border-slate-200 px-3 py-2 text-[13px]" />
      {!rows ? <Loader2 className="h-5 w-5 animate-spin text-violet-500" /> : (
        <div className="max-h-96 overflow-y-auto rounded-xl border border-slate-100">
          <table className="w-full text-left text-[12px]">
            <thead className="bg-slate-50 sticky top-0"><tr className="text-slate-500 font-bold uppercase"><th className="px-3 py-2">When</th><th className="px-3 py-2">Actor</th><th className="px-3 py-2">Action</th><th className="px-3 py-2">Targets</th></tr></thead>
            <tbody className="divide-y divide-slate-100">
              {rows.map((a) => (
                <tr key={a.id}><td className="px-3 py-2 whitespace-nowrap text-slate-500">{new Date(a.at).toLocaleString()}</td>
                  <td className="px-3 py-2 text-slate-700">{a.actor}</td>
                  <td className="px-3 py-2 font-semibold text-slate-700">{a.action.replace(/_/g, " ")}</td>
                  <td className="px-3 py-2 text-slate-400">{(a.target_ids || []).length || (a.meta && a.meta.email) || "—"}</td></tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default function Settings() {
  const [tab, setTab] = useState("allowlist");
  const tabs = [["allowlist", "Access", ShieldCheck], ["audit", "Audit log", ScrollText], ["bin", "Deleted bin", Trash2]];
  return (
    <div className="space-y-4" data-testid="admin-settings">
      <div className="flex gap-2">
        {tabs.map(([k, l, Icon]) => (
          <button key={k} onClick={() => setTab(k)} className={`inline-flex items-center gap-1.5 rounded-full px-3.5 py-1.5 text-[13px] font-semibold ${tab === k ? "bg-slate-900 text-white" : "bg-white border border-slate-200 text-slate-600"}`}>
            <Icon className="h-3.5 w-3.5" /> {l}
          </button>
        ))}
      </div>
      {tab === "allowlist" && <Allowlist />}
      {tab === "audit" && <AuditLog />}
      {tab === "bin" && <LeadsTable deletedBin />}
    </div>
  );
}
